export default __webpack_public_path__ + "assets/images/cf518c676454ceb216028fa6c8d54606.png";